<template>
  <div class="global-settings">
    <el-row :gutter="20" type="flex" class="row-bg">
      <!-- 智能回复配置 -->
      <el-col :span="12">
        <el-card class="box-card full-height" shadow="hover">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-chat-line-round"></i> 智能回复设置</span>
            <el-tag
              v-if="agentConfig.modelType"
              size="small"
              class="float-right"
              >{{ agentConfig.modelType }}</el-tag
            >
            <el-tag v-else type="info" size="small" class="float-right"
              >无活跃模型</el-tag
            >
          </div>

          <div class="setting-item">
            <span class="label">启用智能回复</span>
            <span class="desc">开启后，AI 将自动回复租客发送的消息</span>
            <el-switch
              v-model="smartReplyEnabled"
              @change="handleSmartReplyChange"
            >
            </el-switch>
          </div>

          <el-divider content-position="left">回复提示词配置</el-divider>

          <div class="prompt-header mb-10">
            <el-tag type="info" size="mini">来源: {{ promptSource }}</el-tag>
            <el-button
              type="primary"
              size="mini"
              class="float-right"
              @click="savePrompt"
              :loading="isSavingPrompt"
              v-permissions="['pc:agent:prompt:update']"
              >保存回复提示词</el-button
            >
          </div>

          <el-alert
            v-if="promptSource === 'hardcode'"
            title="当前为默认提示词，保存后将覆盖为自定义配置"
            type="warning"
            show-icon
            :closable="false"
            class="mb-10"
          >
          </el-alert>

          <el-input
            type="textarea"
            class="prompt-textarea"
            placeholder="请输入用于生成回复的系统提示词..."
            v-model="systemPrompt"
          >
          </el-input>
        </el-card>
      </el-col>

      <!-- 内容审核配置 -->
      <el-col :span="12">
        <el-card class="box-card full-height" shadow="hover">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-finished"></i> 内容审核设置</span>
          </div>

          <div class="setting-item">
            <span class="label">启用内容审核</span>
            <span class="desc">对发送的内容进行安全审核，拦截违规信息</span>
            <el-switch v-model="auditEnabled" @change="handleAuditChange">
            </el-switch>
          </div>

          <el-divider content-position="left">审核提示词配置</el-divider>

          <div class="prompt-header mb-10">
            <el-tag type="info" size="mini"
              >来源: {{ auditPromptSource }}</el-tag
            >
            <el-button
              type="primary"
              size="mini"
              class="float-right"
              @click="saveAuditPrompt"
              :loading="isSavingAuditPrompt"
              >保存审核提示词</el-button
            >
          </div>

          <el-alert
            title="请设定明确的审核标准和拦截规则"
            type="info"
            show-icon
            :closable="false"
            class="mb-10"
          >
          </el-alert>

          <el-input
            type="textarea"
            class="prompt-textarea"
            placeholder="请输入用于内容审核的系统提示词..."
            v-model="commentReviewPrompt"
          >
          </el-input>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getActive } from '@/api/system/aiConfig'
import { findByDictCode, updateById } from '@/api/system/dictData'

export default {
  name: 'AiGlobalSettings',
  data () {
    return {
      // 代理配置
      agentConfig: {
        id: null,
        modelType: '',
        smartReply: false
      },
      // 智能回复开关
      smartReplyItem: null,
      smartReplyEnabled: false,

      // 回复提示词
      systemPrompt: '',
      systemPromptItem: null, // 保存完整的字典项对象
      promptSource: 'system_dict',
      isSavingPrompt: false,

      // 审核配置
      auditEnabled: false,
      commentReviewItem: null, // 保存完整的字典项对象
      commentReviewPrompt: '',
      commentReviewPromptItem: null, // 保存完整的字典项对象
      auditPromptSource: 'system_dict',
      isSavingAuditPrompt: false
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      this.loadConfig()
      this.loadDicts()
    },
    // 加载配置
    loadConfig () {
      getActive().then((res) => {
        if (res) {
          this.agentConfig = res
        } else {
          this.agentConfig = {
            id: null,
            modelType: '',
            smartReply: false
          }
        }
      })
    },
    // 加载提示词（从字典）
    loadDicts () {
      findByDictCode({ dictCode: 'sys_ai' }).then((res) => {
        if (res && res.length > 0) {
          res.forEach((item) => {
            if (item.label === 'system_prompt') {
              this.systemPromptItem = item
              this.systemPrompt = item.code
            } else if (item.label === 'comment_review_prompt') {
              this.commentReviewPromptItem = item
              this.commentReviewPrompt = item.code
            } else if (item.label === 'enable_smart_reply') {
              this.smartReplyItem = item
              this.smartReplyEnabled = item.code === '1'
            } else if (item.label === 'enable_comment_review') {
              this.commentReviewItem = item
              this.auditEnabled = item.code === '1'
            }
          })
        }
      })
    },
    // 切换智能回复
    handleSmartReplyChange (val) {
      if (!this.smartReplyItem) {
        this.$tip.error('未找到智能回复开关配置项')
        this.smartReplyEnabled = !val
        return
      }
      const data = {
        id: this.smartReplyItem.id,
        dictId: this.smartReplyItem.dictId,
        label: this.smartReplyItem.label,
        code: val ? '1' : '0'
      }
      updateById(data)
        .then(() => {
          this.$tip.success(val ? '已启用智能回复' : '已禁用智能回复')
          this.smartReplyItem.code = data.code
        })
        .catch((e) => {
          this.smartReplyEnabled = !val // 恢复
          this.$tip.apiFailed(e)
        })
    },
    // 保存回复提示词
    savePrompt () {
      if (!this.systemPromptItem) {
        this.$tip.error('未找到系统提示词配置项')
        return
      }
      this.isSavingPrompt = true
      const data = {
        id: this.systemPromptItem.id,
        dictId: this.systemPromptItem.dictId,
        label: this.systemPromptItem.label,
        code: this.systemPrompt
      }
      updateById(data)
        .then(() => {
          this.$tip.success('系统提示词已更新')
          // 更新本地对象
          this.systemPromptItem.code = this.systemPrompt
        })
        .catch((e) => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isSavingPrompt = false
        })
    },
    // 切换审核开关
    handleAuditChange (val) {
      if (!this.commentReviewItem) {
        this.$tip.error('未找到内容审核开关配置项')
        this.auditEnabled = !val
        return
      }
      const data = {
        id: this.commentReviewItem.id,
        dictId: this.commentReviewItem.dictId,
        label: this.commentReviewItem.label,
        code: val ? '1' : '0',
        disabled: this.commentReviewItem.disabled
      }
      updateById(data)
        .then(() => {
          this.$tip.success(val ? '已启用内容审核' : '已禁用内容审核')
          this.commentReviewItem.code = data.code
        })
        .catch((e) => {
          this.auditEnabled = !val
          this.$tip.apiFailed(e)
        })
    },
    // 保存审核提示词
    saveAuditPrompt () {
      if (!this.commentReviewPromptItem) {
        this.$tip.error('未找到审核提示词配置项')
        return
      }
      this.isSavingAuditPrompt = true
      const data = {
        id: this.commentReviewPromptItem.id,
        dictId: this.commentReviewPromptItem.dictId,
        label: this.commentReviewPromptItem.label,
        code: this.commentReviewPrompt,
        disabled: this.commentReviewPromptItem.disabled
      }
      updateById(data)
        .then(() => {
          this.$tip.success('审核提示词已更新')
          // 更新本地对象
          this.commentReviewPromptItem.code = this.commentReviewPrompt
        })
        .catch((e) => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isSavingAuditPrompt = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.global-settings {
  padding: 20px;
  height: 100%;
}
.row-bg {
  align-items: stretch;
}
.full-height {
  height: 100%;
  display: flex;
  flex-direction: column;

  ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.prompt-textarea {
  flex: 1;
  display: flex;
  flex-direction: column;

  ::v-deep .el-textarea__inner {
    flex: 1;
    resize: none;
    height: 100% !important; /* 强制填满剩余空间 */
    min-height: 300px;
  }
}

.mb-20 {
  margin-bottom: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.float-right {
  float: right;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.setting-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  .label {
    font-weight: bold;
    font-size: 14px;
  }
  .desc {
    color: #909399;
    font-size: 12px;
    flex: 1;
    margin-left: 10px;
  }
}

.prompt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
}
</style>
